
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {throwError as observableThrowError } from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import * as moment from 'moment';

import { LoginService } from '../../login/shared/login.service';
import { DataService } from '../../user-detail.service';
import { environment } from './../../../environments/environment';

@Injectable()
export class AttendanceRecService {
    id: number;

    constructor(
        private http: HttpClient,
        private authenticate: LoginService,
        private dataService: DataService
    ) { 
        this.id = this.dataService.getStaffInformation._id;
    }

    getPreAppDataAdmin(data: any) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/attendance_application/pre_form_data?staff_id='+data.staffId+'&date='+moment(data.targetDate).format('YYYY-MM-DD'), options).pipe(
                    map(this.extractData),
                    catchError(this.handleError),);
    }

    checkAlertError(data: any) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/alert/timestamp_error?staff_id='+data._id+'&date='+data.date, options).pipe(
                    map(this.extractData),
                    catchError(this.handleError),);
    }

    getDailyAlert(date: string, staff_id: any) {
        let params = new HttpParams();
        params = params.set('staff_id', staff_id);
        params = params.set('alert_date', date);
        params = params.set('access_by', this.id.toString());

        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers, params: params };

        return this.http.get(environment.SERVER_URL + '/alert/list_by_staff', options).pipe(
                    map(this.extractData),
                    catchError(this.handleError),);
    }

    private extractData(res: any) {
        let body = res;
        return body.data || {};
    }

    private extract(res: Response | any) {
        let body = res.json();
        return body || {};
    }

    private handleError (error: any) {
        let errMsg: string;
        if (error) {
        const body = error || '';
        const err = body.error || JSON.stringify(body);
        errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
        errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return observableThrowError(errMsg);
    }
}
